// extracted by mini-css-extract-plugin
export default {"cls1":"nhHhi09pY8ysSXu8yMUQ","cls2":"CqHZVROHPrZBo14ku1LZ nhHhi09pY8ysSXu8yMUQ","isTabletDown":"KFany1eRxkTIDCU4sMkS","isDesktopUp":"rZNLlb84UsMWh1MZkLsz"};